import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	stickyOffset?: number
}

export const Container = styled.div<Props>`
	background-color: ${helpers.color.codeBlockBackground};
	border: 1px solid ${helpers.color.border};
	position: sticky;
	top: ${({ stickyOffset = 32 }) => stickyOffset}px;
	height: fit-content;
	margin-top: 32px;
	border-radius: 8px;
`
